import useOffer from 'hooks/Offers/useOffer'
import type { AccommodationItem } from 'tripPlanner/types/tripItem'
import LEHotelSummaryCard from './LEHotelSummaryCard'

interface Props {
  item: AccommodationItem
  offerId: string
  onClose: () => void
}

function SavedLEHotelSummaryCard({ item, offerId, onClose }: Props) {
  const [offer, isLoading] = useOffer<App.HotelOffer>(offerId)

  if (isLoading || !offer) {
    return null
  }

  return <LEHotelSummaryCard offer={offer} tripItem={item} onClose={onClose} />
}

export default SavedLEHotelSummaryCard
